export const websiteEn = {
  website: {
    menu: {
      actions: {
        addItemsPrompt: 'Drag above to add menu items',
        addNewMenuError: 'Please add items into your new menu',
        addTitleError: 'Please add a title for your new menu',
        save: 'Save',
        saved: 'Menu saved!',
      },
      card: {
        navigationTitle: 'Navigation Title',
        showChildren: 'Show Children:',
        showCityPages: 'Show City Pages:',
        translations: 'Translations',
        navigationTitleForLanguage: '{name} Navigation Title',
      },
      editor: {
        all: 'All',
        menuTitle: 'Menu Title',
        menus: 'Menus',
      },
    },
    pages: {
      actions: {
        addRegion: 'Add Region',
        edit: 'Edit',
        manage: 'Manage',
        save: 'Save',
        translations: 'Translations',
      },
      currentPhoto: 'Current Photo',
      fields: {
        city: 'City',
        createTemplate: '--Create Template--',
        description: 'Description',
        featuredImage: 'Featured Image',
        hasDetailsPage: 'Has Details Page',
        newTemplateName: 'New Template Name',
        pageType: 'Page Type',
        parentPage: 'Parent Page',
        publishDate: 'Publish Date',
        regions: 'Regions',
        summary: 'Summary',
        template: 'Template',
        url: 'URL:',
        vanityUrls: 'Vanity URLs (separate each URL on a new line)',
        visibility: 'Visibility',
        showPageInMenu: 'Show Page in Menu',
        showSubPagesInMenu: 'Show Sub Pages in Menu',
      },
      pageTypeOptions: {
        selectPageType: 'Select a Page Type',
        page: 'Page',
        about: 'About',
        apartments: 'Apartments',
        bios: 'Bios',
        blogs: 'Blogs',
        careers: 'Careers',
        cities: 'Cities',
        commercial: 'Commercial',
        communities: 'Communities',
        condos: 'Condos',
        construction: 'Construction',
        contact: 'Contact',
        corporate: 'Corporate',
        documents: 'Documents',
        executiveSuites: 'Executive Suites',
        faqs: 'Faqs',
        forSale: 'For Sale',
        furnishedSuites: 'Furnished Suites',
        gallery: 'Gallery',
        home: 'Home',
        hotels: 'Hotels',
        houses: 'Houses',
        industrial: 'Industrial',
        maintenance: 'Maintenance',
        marinas: 'Marinas',
        military: 'Military',
        motels: 'Motels',
        newDevelopments: 'New Developments',
        news: 'News',
        office: 'Office',
        other: 'Other',
        properties: 'Properties',
        provinces: 'Provinces',
        residential: 'Residential',
        retail: 'Retail',
        rooms: 'Rooms',
        seniors: 'Seniors',
        shortTermSuites: 'Short Term Suites',
        siteSearch: 'Site Search',
        sitemap: 'Sitemap',
        students: 'Students',
        subdivisions: 'Subdivisions',
        testimonials: 'Testimonials',
        townhouses: 'Townhouses',
        unsubscribe: 'Unsubscribe',
        template1: 'Template 1',
        template2: 'Template 2',
        template3: 'Template 3',
        template4: 'Template 4',
        template5: 'Template 5',
      },
      photos: {
        currentPhotoDeleteDescription: 'Delete Description Photo',
        currentPhotoDeleteSummary: 'Delete Summary Photo',
        deletePhotoText: 'Are you sure you want to delete the {type} photo? This action cannot be undone.',
        replaceDescriptionPhoto: 'Replace Current Description Photo',
        replaceSummaryPhoto: 'Replace Current Summary Photo',
        uploadDescriptionPhoto: 'Upload Description Photo',
        uploadSummaryPhoto: 'Upload Summary Photo',
      },
      remove: {
        cityPageTitle: 'Delete City Page',
        cityPageText: 'Are you sure you want to delete the city page "{title}"?',
        pageTitle: 'Remove Page',
        pageText: 'Are you sure you want to remove this page "{title}"? This action cannot be undone.',
        confirmButton: 'Remove',
      },
      savePanelsTooltip: 'Click the "Save Panels" button below to save your content.',
      search: {
        searchCityPlaceholder: 'Search city by name...',
        selectPlaceholder: 'Select...',
      },
      sections: {
        all: 'All',
        cityPageHeader: 'City Page - {title}',
        cityPages: 'City Pages',
        customFields: 'Custom Fields',
        disabled: 'Disabled',
        enabled: 'Enabled',
        hidden: 'Hidden',
        newPlatformFields: 'New Platform Fields',
        pageHeader: 'Page - {title}',
        pages: 'Pages',
        public: 'Public',
        standardContent: 'Standard Content',
      },
      toasts: {
        cityPageSaved: 'City Page saved!',
        imageUploadingTitle: 'Image uploading!',
        imageUploadingMessage: 'Processing image...',
        pageSaved: 'Page saved!',
        urlInvalid: 'URL is invalid',
      },
      translations: {
        disabledTooltip: 'An English value must exist before this {pageType} can be translated. Please save {pageType} before adding translations.',
        pageTypeCity: 'city page',
        pageTypePage: 'page',
      },
      urlModal: {
        editPageUrl: 'Edit Page URL',
        includeParentUrl: 'Include parent page URL (/{parentPermaLink}) in this page\'s URL?',
      },
    },
    posts: {
      actions: {
        addPost: 'Add Post',
        createPost: 'Create Post',
      },
      advanced: {
        attachment: 'Attachment',
        current: 'Current:',
        highlightOnNewListingPage: 'Highlight this post on new listing page',
        originatingUrl: 'Originating URL',
        uploadPdf: 'Upload PDF',
      },
      careerOptions: {
        jobType: {
          contract: 'Contract',
          full_time: 'Full Time',
          not_specified: 'Not Specified',
          part_time: 'Part Time',
          select: 'Select',
          temporary: 'Temporary',
        },
        wageType: {
          apartment_benefit_only: 'Apartment Benefit Only',
          hourly: 'Hourly',
          hourly_with_commission: 'Hourly with Commission',
          commission: 'Commission',
          salary: 'Salary',
          salary_plus_apartment_benefit: 'Salary Plus Apartment Benefit',
          salary_plus_car_allowance: 'Salary Plus Car Allowance',
          salary_plus_commission_plus_housing: 'Salary Plus Commission Plus Housing',
          salary_with_commission: 'Salary with Commission',
          select: 'Select',
          to_be_discussed: 'To Be Discussed',
        },
        yesNo: {
          no: 'No',
          yes: 'Yes',
        },
      },
      content: {
        answer: 'Answer',
        blogTitle: 'Blog Title',
        content: 'Content',
        description: 'Description',
        documentTitle: 'Document Title',
        documentUrl: 'Document URL',
        howToApply: 'How to apply',
        name: 'Name',
        newsTitle: 'News Title',
        positionTitle: 'Position Title',
        postingDetails: 'Posting Details',
        postingSummary: 'Posting Summary',
        question: 'Question',
        summary: 'Summary',
        testimonial: 'Testimonial',
        videoLink: 'Video Link',
      },
      delete: {
        confirmButton: 'Delete',
        successMessage: 'The post has been successfully deleted.',
        text: 'Are you sure you want to delete this post? This action can not be undone.',
        title: 'Delete Post',
      },
      documentCategories: {
        continue: 'Continue',
        deleteInUseWarning: 'One or more of the categories you are deleting is being used by a document. Continuing will remove the category from those document(s)',
        manage: 'Manage Categories',
      },
      fields: {
        author: 'Author',
        categories: 'Categories',
        category: 'Category',
        contactEmail: 'Contact Email',
        contactFax: 'Contact Fax',
        contactName: 'Contact Name',
        contactPhone: 'Contact Phone',
        currentFile: 'Current File',
        date: 'Date',
        email: 'Email',
        externalPostingUrl: 'External Posting URL',
        featuredImage: 'Featured Image',
        imageCaption: 'Image Caption',
        jobType: 'Job Type',
        lastModified: 'Last Modified',
        linkedin: 'Linkedin',
        location: 'Location',
        name: 'Name',
        pageSeoUrl: 'Page/SEO URL',
        phone: 'Phone',
        postingEndDate: 'Posting End Date',
        postingStartDate: 'Posting Start Date',
        postType: 'Post Type',
        publishDate: 'Publish Date',
        publishDateTime: 'Publish Date/Time',
        property: 'Property',
        rating: 'Rating',
        status: 'Status',
        subheader: 'Subheader',
        tag: 'Tag',
        tags: 'Tags',
        title: 'Title',
        travelRequired: 'Travel Required',
        twitter: 'Twitter',
        type: 'Type',
        visibility: 'Visibility',
        wageAmount: 'Wage Amount',
        wageType: 'Wage Type',
        hoursPerWeek: 'Hours per Week',
      },
      filters: {
        all: 'All',
        allStatuses: 'All Statuses',
        postType: 'Post Type',
      },
      help: {
        publishImmediately: 'Leave date/time empty if you want your post published immediately.',
        publishRequiresVisibilityHtml: 'Post will only be shown when <strong>{visibility}</strong> is also set to <em>{published}</em>.',
      },
      images: {
        deleteFeaturedImageText: 'This action cannot be undone. Are you sure you want to delete the featured image?',
        deleteFeaturedImageTitle: 'Delete Featured Image',
        featuredImageUpdated: 'Featured image has been updated',
      },
      modal: {
        createNewPost: 'Create New Post',
        customLeftFooterText: 'Tags can be assigned after the post has been saved.',
        postContent: 'Post Content',
        postType: 'Post Type',
        selectType: 'Select Type...',
        title: 'Title',
        validationMessage: 'Please ensure your post has a title, type, and some content!',
        visibility: 'Visibility',
      },
      newsTypes: {
        article: 'Article',
        events: 'Events',
        news: 'News',
        press_release: 'Press Release',
      },
      placeholders: {
        addCategories: 'Add categories',
        addEmails: 'Add Emails',
        select: 'Select',
        selectTime: 'Select Time',
        time: 'Time',
      },
      sections: {
        advancedSettings: 'Advanced Settings',
        all: 'All',
        content: 'Content',
        customFields: 'Custom Fields',
        hidden: 'Hidden',
        posts: 'Posts',
        published: 'Published',
      },
      sort: {
        name: 'Name',
        publishDate: 'Publish Date',
        title: 'Sort By',
      },
      statuses: {
        hidden: 'Hidden',
        published: 'Published',
      },
      translations: {
        disabledTooltip: 'An English value must exist before this post can be translated. Please save post before adding translations.',
        header: 'Post Content - {title}',
      },
      types: {
        bios: 'Bios',
        blogs: 'Blog',
        careers_postings: 'Careers',
        documents: 'Documents',
        faqs: 'FAQs',
        news: 'News',
        testimonials: 'Testimonials',
      },
    },
    navigation: {
      cityPages: 'City Pages',
      formSettings: 'Form Settings',
      formSubmissions: 'Form Submissions',
      forms: 'Forms',
      globalContent: 'Global Content',
      menu: 'Menu',
      pages: 'Pages',
      posts: 'Posts',
      websiteSettings: 'Website Settings',
    },
    routes: {
      apiKeys: 'APIs & Keys',
      cityPages: 'City Pages',
      customForms: 'Custom Forms',
      customFormsInbox: 'Custom Forms Inbox',
      details: 'Details',
      fieldsBuilder: 'Fields Builder',
      filtersBuilder: 'Filters Builder',
      footerScripts: 'Footer Scripts',
      formSettings: 'Form Settings',
      formDetails: 'Form Details',
      globalContent: 'Global Content',
      globalSettings: 'Global Settings',
      inquiryDetails: 'Inquiry Details',
      languageSettings: 'Language Settings',
      menu: 'Menu',
      pages: 'Pages',
      panelTemplates: 'Panel Templates',
      postDetails: 'Post Details',
      posts: 'Posts',
      settings: 'Settings',
      submissionDetails: 'Submission Details',
      submissions: 'Submissions',
      summaryFieldsBuilder: 'Summary Fields Builder',
      superadminSettings: 'Superadmin Settings',
      tagScripts: 'Tag Scripts',
      websiteDetails: 'Website Details',
      websiteSettings: 'Website Settings',
      websites: 'Websites',
    },
    list: {
      noWebsitesFound: 'No websites found',
      corporateWebsite: 'Corporate Website',
      internalDetails: 'Internal Details',
      onlyVisibleToSuperUsers: 'Only visible to super users',
      siteId: 'Site ID',
      siteKey: 'Site Key',
      sourceClientId: 'Source Client ID',
      visitStaging: 'Visit Staging',
      visitWebsite: 'Visit Website',
    },
    settings: {
      tabs: {
        globalSettings: 'Global Settings',
        formSettings: 'Form Settings',
        tagTranslations: 'Tag Translations',
        regionTranslations: 'Region Translations',
      },
      general: 'General',
      siteTitle: 'Site Title',
      siteLogo: 'Site Logo',
      siteProfile: 'Site Profile',
      sitePhoneNumber: 'Site Phone Number',
      siteAlternatePhoneNumber: 'Site Alternate Phone Number',
      siteFaxNumber: 'Site Fax Number',
      siteMailingAddress: 'Site Mailing Address',
      websiteUrl: 'Website URL',
      city: 'City',
      searchCityByName: 'Search city by name...',
      postalCode: 'Postal Code',
      siteSocialMedia: 'Site Social Media',
      facebookUrl: 'Facebook URL',
      twitterUrl: 'Twitter / X URL',
      linkedinUrl: 'LinkedIn URL',
      youtubeUrl: 'YouTube URL',
      pinterestUrl: 'Pinterest URL',
      instagramUrl: 'Instagram URL',
      tiktokUrl: 'TikTok URL',
      unsavedChanges: 'You have unsaved changes.',
      unableToSaveProfile: 'Currently unable to make changes to Site profile Information.',
      emailSettings: {
        title: 'Site Email Settings',
        defaultEmailAddress: 'Default Email Address',
        fromEmailAddress: 'From Email Address',
        fromEmailWarning: 'Please create a support ticket for managing custom \'From\' email settings.',
        fromName: 'From Name',
      },
      globalTranslations: {
        regions: 'Regions',
        tags: 'Tags',
        regionsWarning: 'Updating translations here will affect all places on your account where Regions are used including Websites.',
        tagsWarning: 'Updating translations here will affect all places on your account where Tags are used including Websites.',
      },
    },
    formSubmissions: {
      search: 'Search',
      date: 'Date',
      formName: 'Form Name',
      removeFilter: 'Remove ({count}) Filter',
      displayUnpublished: 'Display un-published forms',
      noResults: 'No Results Found',
      pickDateRange: 'Pick Date Range to Filter',
      selectFormName: 'Select a Form Name',
      exportTitle: 'Exporting',
      exportMessage: 'Generating Form Submissions lists export',
      customFormsExportMessage: 'Generating Custom Forms lists export',
      inquiriesExportMessage: 'Generating inquiries lists export',
      exportFilename: 'form_submissions',
      customFormsExportFilename: 'custom_forms_lists',
      inquiriesExportFilename: 'inquiries_lists',
      inquiryRemovalTitle: 'Removal in progress',
      inquiryRemovalBody: 'Removing Inquiry',
      deleteTitle: 'Delete Form Submission',
      deleteText: 'Are you sure you want to delete this form submission? This action cannot be undone.',
      deleteCustomFormTitle: 'Delete Custom Form',
      deleteCustomFormText: 'Are you sure you want to delete this custom form? This action cannot be undone.',
      maintenanceBanner: 'To view the responses for your Maintenance Request Form, please visit the Maintenance Requests page.',
      goToMaintenancePage: 'Go to Maintenance Requests Page',
      detail: {
        print: 'Print',
        formName: 'Form Name:',
        email: 'Email:',
        phone: 'Phone:',
        building: 'Building:',
        dateSent: 'Date Sent:',
        message: 'Message:',
        name: 'Name:',
        suiteType: 'Suite Type:',
        bedrooms: 'Bedrooms:',
        moveInDate: 'Move In Date:',
        preferredViewTime: 'Preferred View Time:',
        comments: 'Comments:',
        downloadAttachment: 'Download Attachment',
        downloadError: 'Failed to download attachment',
      },
      adminNotes: {
        title: 'Admin Notes',
        remove: 'Remove',
        add: 'Add',
      },
    },
  },
} as const;

export const websiteFr = {
  website: {
    menu: {
      actions: {
        addItemsPrompt: 'Glissez ci-dessus pour ajouter des éléments de menu',
        addNewMenuError: 'Veuillez ajouter des éléments à votre nouveau menu',
        addTitleError: 'Veuillez ajouter un titre à votre nouveau menu',
        save: 'Enregistrer',
        saved: 'Menu enregistré!',
      },
      card: {
        navigationTitle: 'Titre de navigation',
        showChildren: 'Afficher les enfants :',
        showCityPages: 'Afficher les pages de ville :',
        translations: 'Traductions',
        navigationTitleForLanguage: 'Titre de navigation en {name}',
      },
      editor: {
        all: 'Tous',
        menuTitle: 'Titre du menu',
        menus: 'Menus',
      },
    },
    pages: {
      actions: {
        addRegion: 'Ajouter une région',
        edit: 'Modifier',
        manage: 'Gérer',
        save: 'Enregistrer',
        translations: 'Traductions',
      },
      currentPhoto: 'Photo actuelle',
      fields: {
        city: 'Ville',
        createTemplate: '--Créer un modèle--',
        description: 'Description',
        featuredImage: 'Image en vedette',
        hasDetailsPage: 'A une page de détails',
        newTemplateName: 'Nom du nouveau modèle',
        pageType: 'Type de page',
        parentPage: 'Page parente',
        publishDate: 'Date de publication',
        regions: 'Régions',
        summary: 'Résumé',
        template: 'Modèle',
        url: 'URL :',
        vanityUrls: 'URLs vanité (une URL par ligne)',
        visibility: 'Visibilité',
        showPageInMenu: 'Afficher la page dans le menu',
        showSubPagesInMenu: 'Afficher les sous-pages dans le menu',
      },
      pageTypeOptions: {
        selectPageType: 'Sélectionner un type de page',
        page: 'Page',
        about: 'À propos',
        apartments: 'Appartements',
        bios: 'Biographies',
        blogs: 'Blogues',
        careers: 'Carrières',
        cities: 'Villes',
        commercial: 'Commercial',
        communities: 'Collectivités',
        condos: 'Condos',
        construction: 'Construction',
        contact: 'Contact',
        corporate: 'Entreprise',
        documents: 'Documents',
        executiveSuites: 'Suites exécutives',
        faqs: 'FAQ',
        forSale: 'À vendre',
        furnishedSuites: 'Suites meublées',
        gallery: 'Galerie',
        home: 'Accueil',
        hotels: 'Hôtels',
        houses: 'Maisons',
        industrial: 'Industriel',
        maintenance: 'Entretien',
        marinas: 'Marinas',
        military: 'Militaire',
        motels: 'Motels',
        newDevelopments: 'Nouveaux développements',
        news: 'Nouvelles',
        office: 'Bureau',
        other: 'Autre',
        properties: 'Propriétés',
        provinces: 'Provinces',
        residential: 'Résidentiel',
        retail: 'Commerce de détail',
        rooms: 'Chambres',
        seniors: 'Aînés',
        shortTermSuites: 'Suites à court terme',
        siteSearch: 'Recherche du site',
        sitemap: 'Plan du site',
        students: 'Étudiants',
        subdivisions: 'Subdivisions',
        testimonials: 'Témoignages',
        townhouses: 'Maisons de ville',
        unsubscribe: 'Se désabonner',
        template1: 'Modèle 1',
        template2: 'Modèle 2',
        template3: 'Modèle 3',
        template4: 'Modèle 4',
        template5: 'Modèle 5',
      },
      photos: {
        currentPhotoDeleteDescription: 'Supprimer la photo de description',
        currentPhotoDeleteSummary: 'Supprimer la photo du résumé',
        deletePhotoText: 'Voulez-vous vraiment supprimer la photo {type}? Cette action est irréversible.',
        replaceDescriptionPhoto: 'Remplacer la photo actuelle de description',
        replaceSummaryPhoto: 'Remplacer la photo actuelle du résumé',
        uploadDescriptionPhoto: 'Téléverser une photo de description',
        uploadSummaryPhoto: 'Téléverser une photo de résumé',
      },
      remove: {
        cityPageTitle: 'Supprimer la page de ville',
        cityPageText: 'Voulez-vous vraiment supprimer la page de ville "{title}"?',
        pageTitle: 'Supprimer la page',
        pageText: 'Voulez-vous vraiment supprimer cette page "{title}"? Cette action est irréversible.',
        confirmButton: 'Supprimer',
      },
      savePanelsTooltip: 'Cliquez sur le bouton "Enregistrer les panneaux" ci-dessous pour enregistrer votre contenu.',
      search: {
        searchCityPlaceholder: 'Rechercher une ville par nom...',
        selectPlaceholder: 'Sélectionner...',
      },
      sections: {
        all: 'Tous',
        cityPageHeader: 'Page de ville - {title}',
        cityPages: 'Pages de ville',
        customFields: 'Champs personnalisés',
        disabled: 'Désactivé',
        enabled: 'Activé',
        hidden: 'Masqué',
        newPlatformFields: 'Nouveaux champs de la plateforme',
        pageHeader: 'Page - {title}',
        pages: 'Pages',
        public: 'Publique',
        standardContent: 'Contenu standard',
      },
      toasts: {
        cityPageSaved: 'Page de ville enregistrée!',
        imageUploadingTitle: 'Téléversement de l\'image!',
        imageUploadingMessage: 'Traitement de l\'image...',
        pageSaved: 'Page enregistrée!',
        urlInvalid: 'L\'URL est invalide',
      },
      translations: {
        disabledTooltip: 'Une valeur anglaise doit exister avant que cette {pageType} puisse être traduite. Veuillez enregistrer cette {pageType} avant d\'ajouter des traductions.',
        pageTypeCity: 'page de ville',
        pageTypePage: 'page',
      },
      urlModal: {
        editPageUrl: 'Modifier l\'URL de la page',
        includeParentUrl: 'Inclure l\'URL de la page parente (/{parentPermaLink}) dans l\'URL de cette page?',
      },
    },
    posts: {
      actions: {
        addPost: 'Ajouter un article',
        createPost: 'Créer un article',
      },
      advanced: {
        attachment: 'Pièce jointe',
        current: 'Actuel :',
        highlightOnNewListingPage: 'Mettre cet article en vedette sur la page des nouvelles annonces',
        originatingUrl: 'URL d\'origine',
        uploadPdf: 'Téléverser un PDF',
      },
      careerOptions: {
        jobType: {
          contract: 'Contrat',
          full_time: 'Temps plein',
          not_specified: 'Non spécifié',
          part_time: 'Temps partiel',
          select: 'Selectionner',
          temporary: 'Temporaire',
        },
        wageType: {
          apartment_benefit_only: 'Avantage logement seulement',
          hourly: 'Horaire',
          hourly_with_commission: 'Horaire avec commission',
          commission: 'Commission',
          salary: 'Salaire',
          salary_plus_apartment_benefit: 'Salaire plus avantage logement',
          salary_plus_car_allowance: 'Salaire plus allocation automobile',
          salary_plus_commission_plus_housing: 'Salaire plus commission plus logement',
          salary_with_commission: 'Salaire avec commission',
          select: 'Selectionner',
          to_be_discussed: 'À discuter',
        },
        yesNo: {
          no: 'Non',
          yes: 'Oui',
        },
      },
      content: {
        answer: 'Réponse',
        blogTitle: 'Titre du blogue',
        content: 'Contenu',
        description: 'Description',
        documentTitle: 'Titre du document',
        documentUrl: 'URL du document',
        howToApply: 'Comment postuler',
        name: 'Nom',
        newsTitle: 'Titre de la nouvelle',
        positionTitle: 'Titre du poste',
        postingDetails: 'Détails de l\'affichage',
        postingSummary: 'Résumé de l\'affichage',
        question: 'Question',
        summary: 'Résumé',
        testimonial: 'Témoignage',
        videoLink: 'Lien vidéo',
      },
      delete: {
        confirmButton: 'Supprimer',
        successMessage: 'L\'article a été supprimé avec succès.',
        text: 'Voulez-vous vraiment supprimer cet article? Cette action est irréversible.',
        title: 'Supprimer l\'article',
      },
      documentCategories: {
        continue: 'Continuer',
        deleteInUseWarning: 'Une ou plusieurs catégories que vous supprimez sont utilisées par un document. En continuant, la catégorie sera retirée de ce ou ces documents.',
        manage: 'Gérer les catégories',
      },
      fields: {
        author: 'Auteur',
        categories: 'Catégories',
        category: 'Catégorie',
        contactEmail: 'Courriel du contact',
        contactFax: 'Télécopieur du contact',
        contactName: 'Nom du contact',
        contactPhone: 'Téléphone du contact',
        currentFile: 'Fichier actuel',
        date: 'Date',
        email: 'Courriel',
        externalPostingUrl: 'URL externe de l\'affichage',
        featuredImage: 'Image en vedette',
        imageCaption: 'Légende de l\'image',
        jobType: 'Type d\'emploi',
        lastModified: 'Dernière modification',
        linkedin: 'Linkedin',
        location: 'Lieu',
        name: 'Nom',
        pageSeoUrl: 'URL de page/SEO',
        phone: 'Téléphone',
        postingEndDate: 'Date de fin de l\'affichage',
        postingStartDate: 'Date de début de l\'affichage',
        postType: 'Type d\'article',
        publishDate: 'Date de publication',
        publishDateTime: 'Date/heure de publication',
        property: 'Propriété',
        rating: 'Note',
        status: 'Statut',
        subheader: 'Sous-titre',
        tag: 'Étiquette',
        tags: 'Étiquettes',
        title: 'Titre',
        travelRequired: 'Déplacement requis',
        twitter: 'Twitter',
        type: 'Type',
        visibility: 'Visibilité',
        wageAmount: 'Montant du salaire',
        wageType: 'Type de salaire',
        hoursPerWeek: 'Heures par semaine',
      },
      filters: {
        all: 'Tous',
        allStatuses: 'Tous les statuts',
        postType: 'Type d\'article',
      },
      help: {
        publishImmediately: 'Laissez la date et l\'heure vides si vous voulez publier votre article immédiatement.',
        publishRequiresVisibilityHtml: 'L\'article sera affiché seulement lorsque <strong>{visibility}</strong> est aussi défini sur <em>{published}</em>.',
      },
      images: {
        deleteFeaturedImageText: 'Cette action est irréversible. Voulez-vous vraiment supprimer l\'image en vedette?',
        deleteFeaturedImageTitle: 'Supprimer l\'image en vedette',
        featuredImageUpdated: 'L\'image en vedette a été mise à jour',
      },
      modal: {
        createNewPost: 'Créer un nouvel article',
        customLeftFooterText: 'Les étiquettes peuvent être assignées après l\'enregistrement de l\'article.',
        postContent: 'Contenu de l\'article',
        postType: 'Type d\'article',
        selectType: 'Sélectionner un type...',
        title: 'Titre',
        validationMessage: 'Assurez-vous que votre article a un titre, un type et du contenu!',
        visibility: 'Visibilité',
      },
      newsTypes: {
        article: 'Article',
        events: 'Événements',
        news: 'Nouvelles',
        press_release: 'Communiqué de presse',
      },
      placeholders: {
        addCategories: 'Ajouter des catégories',
        addEmails: 'Ajouter des courriels',
        select: 'Sélectionner',
        selectTime: 'Sélectionner l\'heure',
        time: 'Heure',
      },
      sections: {
        advancedSettings: 'Paramètres avancés',
        all: 'Tous',
        content: 'Contenu',
        customFields: 'Champs personnalisés',
        hidden: 'Masqué',
        posts: 'Articles',
        published: 'Publié',
      },
      sort: {
        name: 'Nom',
        publishDate: 'Date de publication',
        title: 'Trier par',
      },
      statuses: {
        hidden: 'Masqué',
        published: 'Publié',
      },
      translations: {
        disabledTooltip: 'Une valeur anglaise doit exister avant que cet article puisse être traduit. Veuillez enregistrer l\'article avant d\'ajouter des traductions.',
        header: 'Contenu de l\'article - {title}',
      },
      types: {
        bios: 'Bios',
        blogs: 'Blog',
        careers_postings: 'Carrières',
        documents: 'Documents',
        faqs: 'FAQs',
        news: 'Nouvelles',
        testimonials: 'Témoignages',
      },
    },
    navigation: {
      cityPages: 'Pages de ville',
      formSettings: 'Paramètres des formulaires',
      formSubmissions: 'Soumissions de formulaires',
      forms: 'Formulaires',
      globalContent: 'Contenu global',
      menu: 'Menu',
      pages: 'Pages',
      posts: 'Articles',
      websiteSettings: 'Paramètres du site web',
    },
    routes: {
      apiKeys: 'API et cles',
      cityPages: 'Pages de ville',
      customForms: 'Formulaires personnalises',
      customFormsInbox: 'Boite de reception des formulaires personnalises',
      details: 'Details',
      fieldsBuilder: 'Generateur de champs',
      filtersBuilder: 'Generateur de filtres',
      footerScripts: 'Scripts de pied de page',
      formSettings: 'Parametres des formulaires',
      formDetails: 'Details du formulaire',
      globalContent: 'Contenu global',
      globalSettings: 'Parametres generaux',
      inquiryDetails: 'Details de la demande',
      languageSettings: 'Parametres de langue',
      menu: 'Menu',
      pages: 'Pages',
      panelTemplates: 'Modeles de panneau',
      postDetails: 'Détails de l\'article',
      posts: 'Articles',
      settings: 'Parametres',
      submissionDetails: 'Details de la soumission',
      submissions: 'Soumissions',
      summaryFieldsBuilder: 'Generateur de champs resumés',
      superadminSettings: 'Parametres superadmin',
      tagScripts: 'Scripts de balises',
      websiteDetails: 'Details du site web',
      websiteSettings: 'Parametres du site web',
      websites: 'Sites web',
    },
    list: {
      noWebsitesFound: 'Aucun site web trouvé',
      corporateWebsite: 'Site web corporatif',
      internalDetails: 'Détails internes',
      onlyVisibleToSuperUsers: 'Visible uniquement par les super utilisateurs',
      siteId: 'ID du site',
      siteKey: 'Clé du site',
      sourceClientId: 'ID du client source',
      visitStaging: 'Visiter la préproduction',
      visitWebsite: 'Visiter le site web',
    },
    settings: {
      tabs: {
        globalSettings: 'Paramètres généraux',
        formSettings: 'Paramètres des formulaires',
        tagTranslations: 'Traductions des étiquettes',
        regionTranslations: 'Traductions des régions',
      },
      general: 'Général',
      siteTitle: 'Titre du site',
      siteLogo: 'Logo du site',
      siteProfile: 'Profil du site',
      sitePhoneNumber: 'Numéro de téléphone du site',
      siteAlternatePhoneNumber: 'Numéro de téléphone secondaire du site',
      siteFaxNumber: 'Numéro de télécopieur du site',
      siteMailingAddress: 'Adresse postale du site',
      websiteUrl: 'URL du site web',
      city: 'Ville',
      searchCityByName: 'Rechercher une ville par nom...',
      postalCode: 'Code postal',
      siteSocialMedia: 'Médias sociaux du site',
      facebookUrl: 'URL Facebook',
      twitterUrl: 'URL Twitter / X',
      linkedinUrl: 'URL LinkedIn',
      youtubeUrl: 'URL YouTube',
      pinterestUrl: 'URL Pinterest',
      instagramUrl: 'URL Instagram',
      tiktokUrl: 'URL TikTok',
      unsavedChanges: 'Vous avez des modifications non enregistrées.',
      unableToSaveProfile: 'Impossible de modifier les informations du profil du site pour le moment.',
      emailSettings: {
        title: 'Paramètres de courriel du site',
        defaultEmailAddress: 'Adresse courriel par défaut',
        fromEmailAddress: 'Adresse courriel de l\'expéditeur',
        fromEmailWarning: 'Veuillez créer un billet de soutien pour gérer les paramètres de courriel d\'expéditeur personnalisés.',
        fromName: 'Nom de l\'expéditeur',
      },
      globalTranslations: {
        regions: 'Régions',
        tags: 'Étiquettes',
        regionsWarning: 'La mise à jour des traductions ici affectera tous les endroits de votre compte où les régions sont utilisées, y compris les sites web.',
        tagsWarning: 'La mise à jour des traductions ici affectera tous les endroits de votre compte où les étiquettes sont utilisées, y compris les sites web.',
      },
    },
    formSubmissions: {
      search: 'Rechercher',
      date: 'Date',
      formName: 'Nom du formulaire',
      removeFilter: 'Retirer ({count}) filtre',
      displayUnpublished: 'Afficher les formulaires non publiés',
      noResults: 'Aucun résultat trouvé',
      pickDateRange: 'Choisir une plage de dates pour filtrer',
      selectFormName: 'Sélectionner un formulaire',
      exportTitle: 'Exportation',
      exportMessage: 'Génération de l\'exportation de la liste des soumissions de formulaires',
      customFormsExportMessage: 'Génération de l\'exportation de la liste des formulaires personnalisés',
      inquiriesExportMessage: 'Génération de l\'exportation de la liste des demandes',
      exportFilename: 'soumissions_formulaires',
      customFormsExportFilename: 'formulaires_personnalises',
      inquiriesExportFilename: 'demandes',
      inquiryRemovalTitle: 'Suppression en cours',
      inquiryRemovalBody: 'Suppression de la demande',
      deleteTitle: 'Supprimer la soumission de formulaire',
      deleteText: 'Êtes-vous sûr de vouloir supprimer cette soumission de formulaire? Cette action ne peut pas être annulée.',
      deleteCustomFormTitle: 'Supprimer le formulaire personnalisé',
      deleteCustomFormText: 'Êtes-vous sûr de vouloir supprimer ce formulaire personnalisé? Cette action ne peut pas être annulée.',
      maintenanceBanner: 'Pour voir les réponses de votre formulaire de demande de maintenance, veuillez visiter la page des demandes de maintenance.',
      goToMaintenancePage: 'Aller à la page des demandes de maintenance',
      detail: {
        print: 'Imprimer',
        formName: 'Nom du formulaire:',
        email: 'Courriel:',
        phone: 'Téléphone:',
        building: 'Propriété:',
        dateSent: 'Date d\'envoi:',
        message: 'Message:',
        name: 'Nom:',
        suiteType: 'Type de suite:',
        bedrooms: 'Chambres:',
        moveInDate: 'Date d\'emménagement:',
        preferredViewTime: 'Heure de visite préférée:',
        comments: 'Commentaires:',
        downloadAttachment: 'Télécharger la pièce jointe',
        downloadError: 'Échec du téléchargement de la pièce jointe',
      },
      adminNotes: {
        title: 'Notes administrateur',
        remove: 'Supprimer',
        add: 'Ajouter',
      },
    },
  },
} as const;
